<template lang="pug">
el-form(ref="form", label-width="120px", label-position="left", size="small", :model="config", :rules="rules")
  el-form-item.mb-0(label-width="180px", label="待导入数据(来自Excel)")
  el-form-item(label-width="0")
    el-input.keyword(v-model="dataKeyWord", size="mini", placeholder="查找", clearable)
    el-dropdown.filter-column(:hide-on-click="false", trigger="click", size="small")
      i.el-icon-s-tools
      template(#dropdown)
        el-dropdown-menu
          el-input.filter-input(v-model="colFilterText", placeholder="请输入搜索", size="mini", clearable)
            .input-check(slot="append")
              el-checkbox(:value="true", @input="doVisible(true)")
              el-checkbox(:value="false", @input="doVisible(false)")
          el-checkbox-group(v-model="colFilterIndex", :min="1")
            el-dropdown-item(v-for="index in colFilterList", :key="index")
              el-checkbox(:label="index") {{ excelHeader[index] }}
    el-table(height="350px", :data="excelViewData", border)
      el-table-column(v-for="index in formatCheckIndex", min-width="100px", :key="index", :prop="excelHeader[index]", :label="excelHeader[index]")
  el-form-item(label="条件匹配字段", prop="queryMatchFieldMap")
    Mapping(v-for="(item, index) in config.queryMatchFieldMap", :key="index", :item="item", :dicts="dicts.fields")
    el-button(size="mini", icon="el-icon-edit", :disabled="inSubmit", @click="openWhere()")
  el-form-item(label="更新字段", prop="updateMatchFieldMap")
    Mapping(v-for="(item, index) in config.updateMatchFieldMap", :key="index", :item="item", :dicts="dicts.fields")
    el-button(size="mini", icon="el-icon-edit", :disabled="inSubmit", @click="openMapping()")
  el-form-item(label="无匹配记录时")
    el-radio-group(v-model="config.unmatchedProcessingStrategy", :disabled="inSubmit", @change="resetPre")
      el-radio-button(v-for="{ id, cnName } in dicts.noMatch", :key="id", :label="id") {{ cnName }}
  el-form-item(v-if="inPreView || inSubmit", label-width="0")
    el-input.keyword(v-model="preKeyWord", size="mini", placeholder="查找", clearable)
    el-table(:data="preViewData", border, max-height="350px")
      el-table-column(v-slot="{ row }", width="80px", label="结果", align="center")
        el-tooltip(:content="row[preSymbol].import_remark_", :disabled="!row[preSymbol].import_remark_", placement="top")
          span.pre-status(:data-status-name="row[preSymbol].import_status_") {{ row[preSymbol].import_status_ }}
      el-table-column(v-for="col in preColumns", v-bind="col", :key="col.prop")
</template>
<script>
import importSet from "./importSet.vue";
import asyncCom from "@/CommonDP/commons/asyncCom";
import Mapping from "./mapping.vue";
import { cloneDeep, difference, lowerCase, memoize, range, sortBy, trim, union } from "lodash-es";
import { getMetaColumn, preExcelData, savaExcelData } from "./api";
const getField = memoize((listPageId) => getMetaColumn({ listPageId }));
export default {
  components: { Mapping },
  props: {
    excelData: {
      type: Object,
      default: () => ({})
    },
    listPageId: {
      type: String,
      default: ""
    },
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      config: {
        unmatchedProcessingStrategy: 1,
        updateMatchFieldMap: [],
        queryMatchFieldMap: []
        // updateMatchFieldMap: [
        //   {
        //     label: "规模",
        //     field: "employeeNum"
        //   },
        //   {
        //     label: "行业",
        //     field: "industryName"
        //   }
        // ],
        // queryMatchFieldMap: [
        //   {
        //     label: "客户名称",
        //     field: "customerName"
        //   }
        // ]
      },
      preSymbol: Symbol(),
      preData: [],
      preKeyWord: "",
      dataKeyWord: "",
      dicts: {
        fields: [],
        noMatch: [
          { id: 1, cnName: "中止并报错" },
          { id: 2, cnName: "忽略" }
        ]
      },
      rules: {
        updateMatchFieldMap: {
          required: true,
          type: "array",
          message: "至少要选择一个匹配字段"
        },
        queryMatchFieldMap: {
          required: true,
          type: "array",
          message: "至少要选择一个匹配字段"
        }
      },
      colFilterText: "", // 筛选列关键字
      colFilterIndex: [] // 可以查看的excelHeader下标
    };
  },
  computed: {
    // 根据关键字筛选的列下标
    colFilterList() {
      const { colFilterText, excelHeader } = this;
      const text = trim(colFilterText) || "";
      const list = excelHeader.map((label, index) => ({ label, index }));
      const items = text ? list.filter(({ label }) => lowerCase(label).indexOf(lowerCase(text)) > -1) : list;
      return items.map(({ index }) => index);
    },
    // 筛选的列  排序 不得少于一列
    formatCheckIndex() {
      const list = sortBy(this.colFilterIndex);
      if (!list.length) list.push(0);
      return list;
    },
    errPreRows() {
      const successSet = new Set(["更新", "新增"]);
      return this.preData.filter(({ import_status_ }) => !successSet.has(import_status_));
    },
    inPreView() {
      return this.active === 2;
    },
    inSubmit() {
      return this.active === 3;
    },
    mapFields() {
      const {
        config: { queryMatchFieldMap, updateMatchFieldMap }
      } = this;
      return [...queryMatchFieldMap, ...updateMatchFieldMap];
    },
    preViewData() {
      const { excelTable, preSymbol, mapFields, preData } = this;
      return this.matchKeyWord(
        this.preKeyWord,
        excelTable.map((row, index) => {
          const obj = { [preSymbol]: preData[index] };
          for (const { field, label } of mapFields) obj[field] = row[label];
          return obj;
        })
      );
    },
    excelViewData() {
      return this.matchKeyWord(this.dataKeyWord, this.excelTable);
    },
    preColumns() {
      const {
        mapFields,
        dicts: { fields }
      } = this;
      const map = {};
      for (const { columnName, columnDisplayName } of fields) {
        map[columnName] = columnDisplayName;
      }
      const cols = mapFields.map(({ field }) => {
        return { label: map[field], prop: field };
      });
      return cols;
    },
    submitParams() {
      const {
        config,
        excelTable,
        listPageId,
        config: { unmatchedProcessingStrategy }
      } = this;
      const submit = { listPageId, unmatchedProcessingStrategy, dataList: excelTable };
      for (const key of ["queryMatchFieldMap", "updateMatchFieldMap"]) {
        const obj = {};
        if (!config[key]) continue;
        for (const { field, label } of config[key]) obj[label] = field;
        submit[key] = obj;
      }
      return submit;
    },
    excelHeader() {
      return this.excelData.headList || [];
    },
    excelTable() {
      return this.excelData.dataList || [];
    }
  },
  created() {
    this.getField();
    this.colFilterIndex = range(0, this.excelHeader.length);
  },
  methods: {
    doVisible(flag) {
      const fn = flag ? union : difference;
      this.colFilterIndex = fn(this.colFilterIndex, this.colFilterList);
    },
    matchKeyWord(keyword = "", list = []) {
      if (!keyword) return list;
      const str = keyword.toLowerCase();
      return list.filter((row) => Object.values(row).some((val = "") => val && `${val}`.toLowerCase().indexOf(str) > -1));
    },
    preErrMessage() {
      const { preData } = this;
      const map = {};
      for (const { import_status_ } of preData) {
        const num = map[import_status_] || 0;
        map[import_status_] = num + 1;
      }
      const text = Object.keys(map)
        .map((k) => `${k}数据${map[k]}条`)
        .join("，");
      return [text, `共${preData.length}条数据！`].join("。");
    },
    async openPre() {
      await this.$refs.form.validate();
      const { data } = await preExcelData(this.submitParams);
      this.preData = data;
      this.$emit("update:active", 2);
      this.$message.warning(this.preErrMessage());
    },
    async submit() {
      await this.$refs.form.validate();
      const confirmText = this.errPreRows.length ? "存在状态非正常的记录，仍要更新吗？" : "确定导入当前配置的数据";
      await this.$confirm(confirmText, "提示", { type: "warning" });
      const { data } = await savaExcelData(this.submitParams);
      this.preData = data;
      this.$emit("update:active", 3);
      this.$emit("success");
      this.$message.warning(this.preErrMessage());
    },
    resetPre() {
      this.preData = [];
      this.$emit("update:active", 1);
    },
    diffField(fieldMap) {
      const idSet = new Set(fieldMap.map(({ field }) => field));
      return this.dicts.fields.filter(({ columnName }) => !idSet.has(columnName));
    },
    async openWhere() {
      const {
        excelHeader,
        diffField,
        config: { queryMatchFieldMap, updateMatchFieldMap }
      } = this;
      const data = await asyncCom(importSet, { data: cloneDeep(queryMatchFieldMap) }, { title: "条件匹配字段设置", excelHeader, fields: diffField(updateMatchFieldMap) });
      this.config.queryMatchFieldMap = data;
      this.resetPre();
      await this.$refs.form.validate();
    },
    async openMapping() {
      const {
        excelHeader,
        diffField,
        config: { updateMatchFieldMap, queryMatchFieldMap }
      } = this;
      const data = await asyncCom(importSet, { data: cloneDeep(updateMatchFieldMap) }, { title: "匹配字段设置", excelHeader, fields: diffField(queryMatchFieldMap) });
      this.config.updateMatchFieldMap = data;
      this.resetPre();
      await this.$refs.form.validate();
    },
    async getField() {
      const { listPageId } = this;
      const { data } = await getField(listPageId);
      this.dicts.fields = data;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/CommonDP/styles/_theme.scss";
.pre-status {
  font-size: 14px;
  &[data-status-name="更新"],
  &[data-status-name="新增"] {
    color: #2dce54;
  }
  &[data-status-name="忽略"],
  &[data-status-name="未处理"],
  &[data-status-name="已回滚"] {
    color: #f90;
  }
  &[data-status-name="错误"],
  &[data-status-name="缺失"] {
    color: #d20;
  }
}
.mb-0 {
  margin-bottom: 0;
}
.keyword {
  position: absolute;
  right: 0;
  top: -36px;
  width: 240px;
}
.filter-column {
  position: absolute;
  right: 0;
  top: 0px;
  z-index: 1;
  cursor: pointer;
  margin: 8px 16px;
  font-size: 18px;
  transition: all 0.2s;
  &:hover {
    color: $theme-color;
  }
}
.filter-input {
  .input-check {
    .el-checkbox {
      margin-inline: 4px;
    }
  }
  /deep/ .el-input-group__append {
    padding-inline: 4px;
  }
}
.el-dropdown-menu {
  .el-dropdown-menu__item {
    text-align: left;
  }
  .el-checkbox-group {
    width: 300px;
    min-height: 150px;
    .el-checkbox {
      display: block;
    }
  }
}
</style>
